import React from "react";
// componenet
import PaginationItem from "./PaginationItem";
// utilities
import calculatePageNumbers from "@/utilities/CalculatePageNumber";


type TPagination = {
    currentPage: number;
    pageSize: number;
    
    className?: string;
    activeClassName?: string;

    onClick?: (event:React.MouseEvent<HTMLDivElement, MouseEvent>, value:number) => void;

    disabled: boolean;
}


const Pagination = ( props:TPagination ) => {
    console.log("Pagination.rendered", props);    
    
    const onClick = ( event:React.MouseEvent<HTMLDivElement, MouseEvent>, value:number ) => {
        if ( props.onClick ) props.onClick(event, value);
    }

    if ( props.currentPage > 0 ) {

        const [first_page_numbers, middle_page_numbers, last_page_numbers] = calculatePageNumbers( props.currentPage, props.pageSize );

        return (
            <ul className={props.className}>
                { 
                    first_page_numbers?.length > 0 && first_page_numbers.map(
                        (item, index) => <PaginationItem 
                                            key={`pn-${item}`}
                                            currentPage={props.currentPage} 
                                            value={item} 
                                            disabled={props.disabled} 
                                            onClick={onClick} 
                                            activeClassName={props.activeClassName}
                                            className="cursor-pointer page-numbers"
                                        />
                    )
                }
                { 
                    first_page_numbers?.length > 0 && 
                        <li className="disabled"><span className="extend">...</span></li>
                }
                
                { 
                    middle_page_numbers?.length > 0 && middle_page_numbers.map(
                        (item, index) => <PaginationItem 
                                            key={`pn-${item}`}
                                            currentPage={props.currentPage} 
                                            value={item} 
                                            disabled={props.disabled} 
                                            onClick={onClick} 
                                            activeClassName={props.activeClassName}
                                            className="cursor-pointer page-numbers"
                                        />
                    )
                }

                { 
                    last_page_numbers?.length > 0 &&  
                        <li className="disabled"><span className="extend">...</span></li> 
                }

                { 
                    last_page_numbers?.length > 0 && last_page_numbers.map(
                        (item, index) => <PaginationItem 
                                            key={`pn-${item}`}
                                            currentPage={props.currentPage} 
                                            value={item} 
                                            disabled={props.disabled} 
                                            onClick={onClick} 
                                            activeClassName={props.activeClassName}
                                            className="cursor-pointer page-numbers"
                                        />
                    )
                }
            </ul>
        );

    }

    return null;

}

Pagination.defaultProps = {

    activeClassName: "text-white bg-black"

}

const Component = React.memo(Pagination, ( prevProps:TPagination, nextProps:TPagination ) => {
    console.log("Pagination.memo", { prevProps, nextProps });
    return !(
        prevProps.currentPage !== nextProps.currentPage
        || prevProps.pageSize !== nextProps.pageSize
        || prevProps.disabled !== nextProps.disabled
    )
});

export default Component;
